import { parseSearch } from "~/utils/flatbuffers/search"

import type { SearchBuf } from "../generated/search"

import { InterfaceSelection } from "../entity/InterfaceSelection"
import { withStatic } from "../entity/StaticEntity"
import { BaseSearch } from "./BaseSearch"

export class StaticSearch extends withStatic<
  SearchId,
  SearchProperty,
  Search,
typeof BaseSearch
>(BaseSearch) {
  _inner: Search

  constructor(search: Search) {
    super()
    this._inner = markRaw(search)
  }

  inner(): Readonly<Search> {
    return this._inner
  }

  static from(search?: Search) {
    if (search)
      return new StaticSearch(search)
  }

  static fromBuf(buf: SearchBuf): StaticSearch {
    return new StaticSearch(parseSearch(buf))
  }

  /**
   * NOTE: FileEvent is just an alias for File (for now) but this may change
   */
  static fromEvent(event: SearchEvent): StaticSearch {
    return new StaticSearch(event)
  }

  /** When we don't have enough info about a file to type it */
  static blank(id: SearchId) {
    const selection = InterfaceSelection.nothing().inner()
    return new StaticSearch({ id, properties: {}, selection })
  }
}
